import React from 'react';
import { Button, styled } from '@mui/material';
import theme from '../../constants/theme';

export const OutlinedButtonStyled = styled(Button)({
  border: `2px solid ${theme.palette.primary.main}`,
  color: theme.palette.primary.main,
  backgroundColor: theme.palette.transparent.main,
  borderRadius: 'unset',
  fontSize: theme.typography.h5.fontSize,
  textTransform: 'initial',
  height: '40px',
  padding: '0 16px',
  '&:hover': {
    backgroundColor: theme.palette.transparent.main,
  },
});
